export enum AuthenticationType {
  AzureActiveDirectory,
  ActiveDirectory,
  Anonymous,
  AzureB2C,
}
